export function accountSettings() {
  return "/account/profile";
}

export function accountAuthentication() {
  return "/account/authentication";
}

export function accountLoginHistory() {
  return "/account/login-history";
}

export function accountNotifications() {
  return "/account/notifications";
}

export function unauthorized() {
  return "/unauthorized";
}
